import React, { useEffect } from 'react';
import { IonRow, IonCol, IonIcon } from '@ionic/react';
import './Dashboard.scss';
import diamond_logo from '../../assets/images/common/diamond.svg';
import lotus_logo from '../../assets/images/common/lotus.svg';
import { getSkinUrl } from '../../util/urlUtils';
import { BRAND_DOMAIN } from '../../constants/Branding';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../models/RootState';

const ThemeChangesPage = (props) => {
  const history = useHistory();

  const { langData } = useSelector((state: RootState) => state.common)

  console.log('langData', langData)

  useEffect(() => {
    if (BRAND_DOMAIN.toLowerCase().includes('svkbook777.com')) {
      history.push('/home');
    }
  }, []);

  return (
    <>
      <div className="reports-ctn my-wallet-ctn mob-view">
        <div className="carw mob-view">
          <div className="arrow arrow-right">
            <div className="name">{langData?.['changesite']}</div>
          </div>
        </div>

        <div className="dashboard-ctn">
          <IonRow className="dashboard-cards-ctn">
            <IonCol
              className="dashboard-item"
              sizeXs="12"
              sizeSm="12"
              sizeMd="12"
            >
              <div
                className="dashboard-item-link"
                onClick={() =>
                  window.open(
                    `https://${getSkinUrl(
                      'lotus'
                    )}/?authToken=${sessionStorage.getItem('jwt_token')}`,
                    '_self'
                  )
                }
              >
                <div className="ion-ctn">
                  <IonIcon
                    className={'dashboard-item-icon'}
                    color="primary"
                    src={lotus_logo}
                  />
                </div>
                <span className="dashboard-item-text">{langData?.['lotus']}</span>
              </div>
            </IonCol>
            <IonCol
              className="dashboard-item"
              sizeXs="12"
              sizeSm="12"
              sizeMd="12"
            >
              <div
                className="dashboard-item-link"
                onClick={() =>
                  window.open(
                    `https://${getSkinUrl(
                      'diamond'
                    )}/?authToken=${sessionStorage.getItem('jwt_token')}`,
                    '_self'
                  )
                }
              >
                <div className="ion-ctn">
                  <IonIcon
                    className={'dashboard-item-icon'}
                    color="primary"
                    src={diamond_logo}
                  />
                </div>
                <span className="dashboard-item-text">{langData?.['diamond']}</span>
              </div>
            </IonCol>
          </IonRow>
        </div>
      </div>
    </>
  );
};



export default ThemeChangesPage;
